import { render, staticRenderFns } from "./GroupsViewModal.vue?vue&type=template&id=3f1fa320"
import script from "./GroupsViewModal.vue?vue&type=script&lang=js"
export * from "./GroupsViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports